export const sv = {
  accepting: 'Accepterar inbjudan…',
  errGeneric: 'Inbjudan kunde inte accepteras. Försök igen eller be verkstaden skicka en ny.',
  goToLogin: 'Gå till inloggning',
}

export const en: typeof sv = {
  accepting: 'Accepting invitation…',
  errGeneric: 'The invitation could not be accepted. Try again or ask the garage to send a new one.',
  goToLogin: 'Go to login',
}
